<template>
  <div id="admingrouptree">
    <el-row>
      <el-col :span="12">
        <el-button size="mini" @click="handleAddTop">添加顶级分组</el-button>
        <el-tree
          :data="tree"
          :props="defaultProps"
          node-key="id"
          highlight-current
          :expand-on-click-node="false"
          :default-expanded-keys="expanded"
          :render-content="renderContent"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </el-col>
      <el-col v-loading="loading" :span="12">
        关联角色管理
        <el-button type="primary" size="mini" @click="submitRole()">
          提交</el-button
        >
        <el-tree
          ref="roleTree"
          :data="roleTree"
          :props="roleProps"
          :check-strictly="true"
          node-key="id"
          show-checkbox
          :default-checked-keys="roleChecked"
          :default-expanded-keys="roleExpanded"
        >
        </el-tree>
        <el-button type="primary" size="mini" @click="submitRole()">
          提交</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TreeRender from "../components/TreeRender.vue";

export default {
  name: "Admingrouptree",
  data() {
    return {
      filterText: "",
      tree: [],
      expanded: [],
      isEdit: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      roleTree: [],
      roleExpanded: [],
      roleChecked: [],
      roleProps: {
        children: "children",
        label: "label",
      },
      mcaGroupId: 0,
      loading: false,
    };
  },
  created() {
    /* 获取菜单列表数据 */
    const _this = this;
    this.$http.post("/erp/AdminGroup/getAdminGroupTree").then((res) => {
      if (res.data.code === 200) {
        _this.tree = res.data.data.tree;
        _this.initExpand();
      }
    });
  },
  methods: {
    renderContent(h, { node, data, store }) {
      const that = this; // 指向vue
      return h(TreeRender, {
        props: {
          DATA: data, // 节点数据
          NODE: node, // 节点内容
          STORE: store, // 完整树形内容
          maxexpandId: that.non_maxexpandId,
        },
        on: {
          // 绑定方法
          nodeAdd: (s, d, n) => that.handleAdd(s, d, n),
          nodeEdit: (s, d, n) => that.handleEdit(s, d, n),
          nodeDel: (s, d, n) => that.handleDelete(s, d, n),
          nodeEditPass: (s, d, n) => that.nodeEditPass(s, d, n),
        },
      });
    },
    handleAddTop() {
      this.tree.push({
        id: 0,
        name: "新增节点",
        pid: 0,
        isEdit: true,
        children: [],
      });
    },
    handleAdd(s, d, n) {
      // 增加节点
      // 添加数据
      d.children.push({
        id: 0,
        label: "子分组",
        pid: d.id,
        isEdit: true,
        children: [],
      });
      // 展开节点
      if (!n.expanded) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        n.expanded = true;
      }
    },
    handleEdit() {
      // 编辑节点
    },
    handleDelete(s, d, n) {
      // 删除节点
      const _this = this;
      // 有子级不删除
      if (d.children && d.children.length !== 0) {
        this.$message.error("此节点有子级，不可删除！");
        return;
      }
      // 删除操作
      const delNode = () => {
        const list = n.parent.data.children || n.parent.data;
        // 节点同级数据，顶级节点时无children
        let _index = 99999; // 要删除的index
        list.forEach((c, i) => {
          if (d.id == c.id) {
            _index = i;
          }
        });
        const k = list.splice(_index, 1);
        /* 删除节点 */
        k.forEach((c) => {
          /* 向后台请求删除数据 */
          this.$http
            .post("/erp/AdminGroup/delGroup", {
              group_id: c.id,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                _this.$message.error(res.data.msg);
                return;
              }
              _this.$message.success("删除成功！");
            });
        });
      };
      const isDel = () => {
        _this
          .$confirm("是否删除此节点？", "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            delNode(); // 此处可通过ajax做删除操作
          })
          .catch(() => {
            return false;
          });
      };
      // 新增节点直接删除，否则要通过请求数据删除
      if (d.id > this.non_maxexpandId) {
        delNode();
      } else {
        isDel();
      }
    },
    nodeEditPass(s, d) {
      // 提交通过
      if (!d.label || d.label === "") {
        return;
      }
      /* 向后台请求并保存数据 */
      this.$http
        .post("/erp/AdminGroup/save", {
          group_id: d.id,
          group_name: d.label,
          pid: d.pid,
          sort: d.sort,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          if (res.data.data.info) {
            d.id = res.data.data.info.group_id;
          }
        });
    },
    handleNodeClick(d) {
      // 点击节点
      d.isEdit = false; // 放弃编辑状态
      this.loading = true;
      this.initRole(d.id);
    },
    initExpand() {
      this.tree.forEach((a) => {
        this.expanded.push(a.id);
      });
    },
    initRole(id) {
      // 初始关联的权限数据
      const _this = this;
      this.mcaGroupId = id;
      this.$http
        .post("/erp/AdminGroup/getAdminGroupToRoleTree", {
          group_id: id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            _this.roleTree = res.data.data.tree;
            _this.roleExpanded = res.data.data.checked;
            _this.$refs.roleTree.setCheckedKeys(res.data.data.checked);
          }
          _this.loading = false;
          if (res.data.code !== 200) {
            _this.roleTree = [];
            _this.$message.error(res.data.msg);
          }
        });
    },
    submitRole() {
      const _this = this;
      /* 提交权限关联数据 */
      this.$http
        .post("/erp/AdminGroup/saveAdminGroupJoinRole", {
          group_id: this.mcaGroupId,
          role_ids: this.$refs.roleTree.getCheckedKeys(),
        })
        .then((res) => {
          if (res.data.code !== 200) {
            _this.$message.error(res.data.msg);
            return;
          }
          if (res.data.code === 200) {
            _this.$message({
              type: "success",
              message: "修改成功!",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.expand-tree .is-current > .el-tree-node__content .tree-btn,
.expand-tree .el-tree-node__content:hover .tree-btn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminGroupTree.vue